import { Col, Form, Row, Typography } from "antd";
import GeneralFavoriteList from "apps/Common/FavoriteList/GeneralFavoriteList";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { addFavoriteAdvert } from "apps/CustomerPanel/Favorite/Pages/Ads/Services";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import useMazakaForm from "hooks/useMazakaForm";
import { FC } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store/Reducers";

const AddFavoriteList: FC<{ onFinish?: any; selectedRecord?: any }> = ({
  onFinish,
  selectedRecord,
}) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { Text } = Typography;
  const { userInfoes } = useSelector((state: RootState) => state.profile);

  const handleOnFinish = async () => {
  
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    try {
      const data = {
        advertId: selectedRecord?.id || null,
        favoriteListId: formValues["listId"],
      };
      await addFavoriteAdvert(data);
      mazakaForm.setSuccess(2000, () => "İlan listeye eklendi");
      form.resetFields();
      onFinish();
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      openNotificationWithIcon("default", error?.message);
      console.log("somethings wrong wehen adding ad ad to favorite", error);
    }
  };
  return (
    <>
      <Col
        xs={24}
        className="!w-full !h-full !p-4"
        onClick={(e) => {
          if ((e.target as HTMLElement).tagName !== "BUTTON") {
            e.stopPropagation(); 
          }
        }}
      >
        <MazakaForm
          form={form}
          onFinish={handleOnFinish}
          submitButtonVisible={false}
          {...formActions}
        >
          <Row gutter={[20, 20]}>
            <Col xs={24} className="!flex justify-center">
              <Text className="!text-2xl !font-bold !text-black">
                İlanı Favoriye Ekle
              </Text>
            </Col>

            <GeneralFavoriteList
              xs={24}
              rules={[{ required: true, message: "" }]}
              label="Favori Listesi"
              placeholder="Favori Listesi"
              externalValueId={userInfoes.id}
              name="listId"
              form={form}
            />
            <Col xs={24}>
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                processType={formActions.submitProcessType}
              >
                Favorilere Ekle
              </MazakaButton>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default AddFavoriteList;
